// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"d00c0905","657":"c1cd02e6"}[chunkId] + ".chunk.css";
};